export const ROUTE_NAMES = {
	HOME: '/',
	COMPANY: '/about-us',
	PROJECTS: '/projects',
	TEAM: '/team',
	BLOG: '/blog',
	PRESS: '/press',
	PRESS1:
		'/press/construction-starts-on-21-hollywood-at-2100-n-federal-highway-hollywood-fl-33020',
	PRESS2:
		'/press/21-hollywood-a-new-13-story-mixed-use-apartment-development-is-coming-to-the-heart-of-hollywood',
	PRESS3:
		'/press/exclusive-iconic-starlife-groups-21-hollywood-recognized-as-the-best-in-luxury-real-estate',
	PRESS4:
		'/press/the-future-of-luxury-real-estate-an-exclusive-interview-with-gevorg-shahbazyan-visionary-founder-of-starlife-group',
	PRESS5:
		'/press/starlife-group-founder-and-ceo-gevorg-shahbazyan-named-young-developer-of-the-year-at-the-red-awards-florida-2025',
	PRESS6:
		'/press/bardi-vp-starlife-receive-green-light-for-200-unit-apartment-project-in-hollywood-fl',
	PRESS7:
		'/press/luxury-at-its-finest-21-hollywood-by-starlife-group-wins-prestigious-industry-award',
	PRESS8: '/press/starlife-group-building-hollywood-apartment-project',
	PRESS9:
		'/press/first-concrete-poured-as-construction-progresses-on-21-hollywood',
	PRESS10:
		'/press/foundation-work-progresses-on-21-hollywood-at-2100-n-federal-highway-in-hollywood-florida',
	PRESS11:
		'/press/the-urban-blueprint-rewritten-21-hollywood-by-starlife-group',
	PRESS12:
		'/press/starlife-group-honored-as-a-winner-in-first-season-of-the-2025-titan-property-awards-for-21-hollywood-development-1f102137e1b196b9203d79abde5cd662',
	CONTACT: '/contact-us',
	INVEST: '/invest-in-project',

	DEVELOPMENTDESIGN: '/development-services',
	REALESTATEDEVELOPMENT:
		'/development-and-design-services/real-estate-development',
	PREDEVELOPMENTPLANNING:
		'/development-and-design-services/pre-development-planning',
	DESIGNBUILD: '/development-and-design-services/design-build',
	SMARTSUSTAINABLE: '/development-and-design-services/smart-building',

	CAPITALINVESTMENT: '/capital-services',
	CAPITALVENTURES: '/capital-and-investment-services/capital-ventures',
	LENDINGSOLUTIONS: '/capital-and-investment-services/lending-solutions',
	EBSERVICE: '/capital-services/eb-5',

	CONSTRUCTIONSERVICE: '/construction-services',
	BROKERAGESERVICES: '/brokerage-services',
	MORTGAGESERVICES: '/mortgage-services',
	LENDINGSERVICES: '/lending-services',
	ELITEPROPERTYMANAGMENT:
		'/asset-and-property-services/elite-property-management',

	STARLIFEPLAZA: '/projects/starlife-plaza',
	HOLLYWOOD: '/projects/hollywood',
	RIVERLANDMANSION: '/projects/riverland-mansion',
	RIVERLANDESTATES: '/projects/riverland-estates',
	CORALRIDGEVILLAS: '/projects/coral-ridge-villas',
	CORALRIDGERESIDENCES: '/projects/coral-ridge-residences',
	DANIABEACHVILLAS: '/projects/dania-beach-villas',
};
